import { useLocation, Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">{t('notFoundTitle')}</h1>
        <p className="mt-2 text-base text-foreground-600 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-700">{t('notFoundDesc')}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          {t('notFoundCta')}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </div>
  );
}